// Demo report ID - globally visible but immutable for client mutations
export const DEMO_REPORT_ID = "00000000-0000-0000-0000-000000000000";

// Check if a record is the demo report
export const isDemoReport = (recordId: string): boolean => {
  return recordId === DEMO_REPORT_ID;
};
